
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#474747","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"15"}},[_c('path',{attrs:{"d":"M16.219 293.144l69.342 46.247s50.749-19.571 71.493-19.42a19.35 19.35 0 016.661.317l79.176 17.885c10.257 2.317 17.192 12.267 15.24 22.6-2.048 10.848-12.656 17.746-23.333 15.335l-29.392-6.639-32.438-7.429c-6.005-1.371-11.984 2.377-13.359 8.38-1.374 6.003 2.377 11.984 8.38 13.359l94.336 20.967c.838.192 1.675.23 2.499.23h.007s1.787.083 3.292-.42l88.698-33.636c8.561-3.182 18.109 1.341 21.014 10.088 2.768 8.333-1.861 17.339-10.09 20.4l-91.05 43.605a28.074 28.074 0 01-10.208 2.095c-22.961.363-122.936 1.745-128.678 1.231-6.696-.605-121.592-53.99-121.592-53.99m.002-263.508l82.243 27.223s55.214 42.209 74.602 49.588a19.365 19.365 0 006.323 2.12l80.273 12.037c10.4 1.559 20.469-5.199 22.397-15.537 2.024-10.852-5.361-21.127-16.186-22.751l-29.8-4.469-32.924-4.836c-6.094-.899-10.307-6.56-9.412-12.654.895-6.093 6.56-10.307 12.654-9.412l98.047 14.66 80.866 45.777c17.141 8.571 37.987 1.729 46.716-15.332h0a1.706 1.706 0 00-.68-2.263l-123.696-77.94s-91.115-30.783-96.652-32.386c-6.46-1.863-77.666-10.923-77.666-10.923L16.219 15.45"}}),_c('path',{attrs:{"d":"M260.572 321.379c3.645-6.632 7.465-12.876 10.69-17.86 9.567 15.106 24.45 41.437 24.45 54.761 0 3.605-.942 7.014-2.613 10.03M285 248.449l9.1-12.522c7.232-9.951 20.896-16.116 35.721-16.116h120.593c17.732 0 34.503-6.198 45.581-16.846v0M404.395 222.033v64.319M331.116 349.977v-38.089c0-14.103 11.433-25.536 25.536-25.536h95.488c14.103 0 25.536 11.433 25.536 25.536v185.88M331.116 497.768V449.7"}})])])
          )
        }
      }
    